import { Col, Row } from "react-bootstrap";
import { ITableHeader } from "../../oversight-core/interfaces/table-header";
import { ITableRowProps } from "../../oversight-core/interfaces/table-row-props";
import MaterialIcon from "../../oversight-core/ui-elements/material-icon/material-icon";
import SitesTableRow from "./site-table-row/site-table-row";
import styles from "./sites-table.module.scss";

interface IProps {
  headers: ITableHeader[];
  data: ITableRowProps[];
}

const SitesTable = (props: IProps) => {
  const { headers, data } = props;

  return (
    <div
      className={styles[`table-grid`]}
      style={{ gridTemplateColumns: `repeat(${headers.length}, 1fr)` }}
    >
      {headers.map((header) => (
        <Row
          key={header.id}
          className="row-cols-auto align-items-center px-3 py-2 cursor-pointer"
          onClick={() => header.sortFunction?.()}
        >
          <Col className="pe-0 text-dark font-weight-400 font-size-12">
            {header.columnName}
          </Col>
          {header.isSort && (
            <Col className="ps-2">
              <MaterialIcon
                icon={header.sort ? `arrow_downward` : `arrow_upward`}
                color="#383941"
                size={13}
                weight={700}
              />
            </Col>
          )}
        </Row>
      ))}
      {data &&
        data.map((item, index) => <SitesTableRow key={index} {...item} />)}
    </div>
  );
};

export default SitesTable;
